<template>
  <el-dialog
    :visible.sync="isFormDialogVisible"
    custom-class="fifl-dialog"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :append-to-body="true"
    top="20px"
  >
    <div
      slot="title"
      class="dialog-header"
    >
      <h2>
        {{ isModify ? '락커 수정' : '락커 추가' }}
      </h2>
    </div>
    <el-form
      label-position="top"
      label-width="100px"
    >
      <el-row :gutter="15">
        <el-col
          :sm="24"
          :lg="12"
        >
          <el-form-item label="락커 선택">
            <el-select v-model="form.room">
              <el-option
                v-for="room in availableRooms"
                :key="room.id"
                :label="room.name"
                :value="room.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="락커 기간">
            <el-row :gutter="15">
              <el-col :span="12">
                <el-date-picker
                  v-model="dateRange.start"
                  type="date"
                  placeholder="시작일"
                />
              </el-col>
              <el-col :span="12">
                <el-date-picker
                  v-model="dateRange.end"
                  type="date"
                  placeholder="종료일"
                  :picker-options="endDatePickerOption"
                />
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="form-divide-line" />

      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="카드">
            <div class="el-input-group__unit">
              <el-input-comma-number
                v-model="form.card"
                controls-position="right"
                @focus="selectAllOnFocus"
              />
              <div class="input-unit">
                원
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="현금">
            <div class="el-input-group__unit">
              <el-input-comma-number
                v-model="form.cash"
                controls-position="right"
                @focus="selectAllOnFocus"
              />
              <div class="input-unit">
                원
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="미수금">
            <div class="el-input-group__unit">
              <el-input-comma-number
                v-model="form.remainder"
                controls-position="right"
                @focus="selectAllOnFocus"
              />
              <div class="input-unit">
                원
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="결제 금액">
            <div class="el-input-group__unit">
              <el-input
                placeholder="자동 입력"
                :value="paidAmount"
              />
              <div class="input-unit">
                원
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col
          :sm="24"
          :lg="12"
        >
          <el-form-item label="결제일">
            <el-date-picker
              v-model="form.paid_at"
              type="date"
              placeholder="선택"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <dialog-action-buttons
      ref="dialogActionButtons"
      slot="footer"
      @cancel="closeDialog"
      @confirm="saveForm"
    />
  </el-dialog>
</template>

<script>
import FormDialog from "@/components/AbstractComponents/FormDialog.vue";
import DialogActionButtons from "@/components/dialogActionButtons";
import ElInputCommaNumber from '@/components/element-ui/ElInputCommaNumber';
import { fiflboxApi } from '@/utils/api';
import { numberWithCommas } from "@/utils/etc"

export default {
	name: "LockerFormDialog",
	components: { DialogActionButtons,  ElInputCommaNumber },
	extends: FormDialog,
	props: ["enrollmentId", "data", "gender"],
	data() {
		return {
			rooms: [],
			isModify: false,
			isFormDialogVisible: false,
			dateRange: {
				start: null,
				end: null,
			},
			form: {
				room: null,
				enrollment: null,
				start: null,
				duration: null,
				card: 0,
				cash: 0,
				remainder: 0,
				paid_at: null,
			},
		};
	},
	computed: {
		endDatePickerOption() {
			let startDate = this.dateRange.start;

			return {
				disabledDate(time) {
					if (startDate) {
						return time.getTime() < startDate;
					}

					return false;
				},
			};
		},
		paidAmount() {
			return numberWithCommas(Number(this.form.card) + Number(this.form.cash));
		},
		availableRooms() {
			if (this.form.room != null) {
				return this.rooms.filter(room => {
					if (room.id === this.form.room) {
						return true;
					}

					return !room.using_now && !room.is_paused;
				});
			}

			return this.rooms.filter(room => {
				return !room.using_now && !room.is_paused;
			});
		},
	},
	watch: {
		async gender() {
			await this.syncLockerData();
		},
	},
	async mounted() {
		await this.syncLockerData();
	},
	methods: {
		selectAllOnFocus(event) {
			event.target.select();
		},
		async syncLockerData() {
      let { data: rooms } = await fiflboxApi.v1.getLockerRooms({
        gender: 0,
      })
      
      let { data: genderRooms } = await fiflboxApi.v1.getLockerRooms({
        gender: this.gender == 1 ? 1 : 2,
      })

			this.rooms = rooms.concat(genderRooms);
		},
		clearData() {
			this.form = {
				room: null,
				enrollment: null,
				start: null,
				duration: null,
				card: 0,
				cash: 0,
				remainder: 0,
				paid_at: new Date(),
			};

			this.dateRange = {
				start: null,
				end: null,
			};
		},
		openDialogToAdd({ enrollmentId }) {
			this.clearData();
			this.isModify = false;
			this.form.enrollment = enrollmentId;
			this.isFormDialogVisible = true;
		},
		openDialogToModify(data) {
			this.clearData();
			this.isModify = true;
			this.form = Object.assign({}, data);
			this.form.room = this.form.room.id;
			this.dateRange = {
				start: this.form.start,
				end: this.form.end,
			};
			this.isFormDialogVisible = true;
		},
		closeDialog() {
			this.isFormDialogVisible = false;
		},
		async saveForm() {
			this.form.start = this.dateRange.start;
			this.form.end = this.dateRange.end;
			try {
				if (this.form.id) {
          await fiflboxApi.v1.putLockerHistories(this.form.id, this.form);
				} else {
					await fiflboxApi.v1.postLockerHistories(this.form);
				}

				this.$message(
					this.isModify ? "락커가 수정됐습니다." : "락커가 등록됐습니다."
				);
				this.closeDialog();
				this.$emit("update");
			} catch (err) {
				this.$alert(
					"락커 등록에 실패했습니다. 락커 상태를 확인해주세요.",
					"락커 등록 오류",
					{
						confirmButtonText: "확인",
						showClose: false,
						customClass: "fifl-message-box",
						confirmButtonClass: "gray",
					}
				);
			} finally {
				this.$refs["dialogActionButtons"].stopLoading();
			}
		},
	},
};
</script>

<style scoped>
</style>
